'use strict';

import execute_on from "../../../libs/execute-on";

execute_on('admin.points-package.assign-to-company', pointsPackageScript);

function pointsPackageScript($page) {
    $page.on('click', '.preventSubmit', function (event) {
        event.preventDefault();

        const $form = $(this).closest('form');
        const $selectAllContainer = $form.find('#selectAllContainer');
        const dataTable = $('.table.dataTable').DataTable();
        const selectedRows = dataTable.rows(function (idx, data, node) {
            let cells = $(node).find('input[type="checkbox"]');
            return checkedTargets(cells).length;
        })
            .data()

        $selectAllContainer.html('');
        selectedRows.each(function (row) {
            let checkbox = $(row[0]).find('input[type=checkbox]');
            checkbox.attr('value', '1');
            checkbox.attr('type', 'hidden');
            checkbox.attr('class', '');
            $selectAllContainer.append(checkbox);
        })

        $(this).closest('form').submit();
        return false;

    });

    function checkedTargets(checkboxes) {
        return checkboxes.filter(function (index) {
            return $(checkboxes[index]).prop('checked');
        });
    }

    $('#special_offer').on('change', function (e) {
        $('.special_offer').slideToggle();
        $('.special_offer input').prop('disabled', !e.target.checked);
    });
}
